"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Position = void 0;
/**
 * Describes possible positions within a container. Two letter abbreviations are
 * YX - [top, center, bottom] and [left, center, right] respectively.
 * E.g. TL = "Top Left". INLINE = "none of the above, break onto own line"
 */
var Position;
(function (Position) {
    /** Top Left */
    Position["TL"] = "tl";
    /** Center Left */
    Position["CL"] = "cl";
    /** Bottom Left */
    Position["BL"] = "bl";
    /** Top Center */
    Position["TC"] = "tc";
    /** Center Center */
    Position["CC"] = "cc";
    /** Bottom Center */
    Position["BC"] = "bc";
    /** Top Right */
    Position["TR"] = "tr";
    /** Center Right */
    Position["CR"] = "cr";
    /** Bottom Right */
    Position["BR"] = "br";
    /** Break into inline block */
    Position["INLINE"] = "inline";
})(Position = exports.Position || (exports.Position = {}));
